import { useState, useEffect, useCallback } from "react";
import { FaSearch } from "react-icons/fa";
import SideNave from "../common/sidenav";
import TopNav from "../common/topnav";
import "../common/style.css";
import "./manageBatch.css";
import { useNavigate } from "react-router-dom";
import { showProjects } from "../http/api";
import Loading from "../loading/loading";
import { useAuth } from "../http/authcontex";

export default function ShowProjectsInManageBatch() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const authContext = useAuth();

  const [isSidebarOpen, setIsSidebarOpen] = useState(
    localStorage.getItem("sb|sidebar-toggle") === "true"
  );

  const [projects, setProjects] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredProjects, setFilteredProjects] = useState([]);

  useEffect(() => {
    localStorage.setItem("sb|sidebar-toggle", isSidebarOpen);
  }, [isSidebarOpen]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    localStorage.setItem("sb|sidebar-toggle", !isSidebarOpen);
  };

  const viewProjectData = useCallback(() => {
    setLoading(true);
    showProjects()
      .then((response) => {
        if (response.status === 200) {
          const projectData = response.data.map((item) => ({
            id: item.id,
            active: item.active,
            details: item.details,
            locations: item.locations,
            name: item.name,
            print_address: item.print_address,

            // if API already returns these extra fields, keep them
            projectType: item.projectType,
            startDate: item.startDate,
            endDate: item.endDate,
            subCategory: item.subCategory,
            subScheme: item.subScheme,
            targetNumber: item.targetNumber,
            trainingType: item.trainingType,
            fundedBy: item.fundedBy,
          }));

          setProjects(projectData);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        if (error.response && error.response.status === 401) {
          console.error("Unauthorized access, redirecting to login...");
          authContext.logout();
          navigate("");
        } else {
          console.error("Error fetching project details:", error);
        }
      });
  }, [authContext, navigate]);

  useEffect(() => {
    viewProjectData();
  }, [viewProjectData]);

  // Filter projects whenever searchTerm or projects change
  useEffect(() => {
    const filtered = (projects || []).filter((project) =>
      Object.values(project || {}).some(
        (value) =>
          typeof value === "string" &&
          value.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
    setFilteredProjects(filtered);
  }, [searchTerm, projects]);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleAddBatch = (projectId) => {
    // Navigate to a new page or open a modal to add a batch for the specified project
    navigate(`/addBatch/${projectId}`);
  };

  const handleManageBatch = (projectId) => {
    // Navigate to the manage batch page for the specified project
    navigate(`/manageBatch/${projectId}`);
  };

  const getCardColor = (id) => {
    const colors = [
      "#FFC107",
      "#17A2B8",
      "#DC3545",
      "#28A745",
      "#6C757D",
      "#007BFF",
    ];
    return colors[id % colors.length];
  };

  return (
    <div className="ShowProjects">
      {loading && <Loading />}
      <div
        className={`sb-nav-fixed ${isSidebarOpen ? "sb-sidenav-toggled" : ""}`}
      >
        <TopNav toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div id="layoutSidenav">
          <SideNave isSidebarOpen={isSidebarOpen} />
          <div id="layoutSidenav_content">
            <main>
              <div className="container-fluid px-4">
                <h4 className="mt-4">Manage Batch</h4>
                <div className="mb-3">
                  <div className="d-flex justify-content-end align-items-center">
                    <div className="d-flex align-items-center">
                      <input
                        type="text"
                        placeholder="Search..."
                        className="form-control me-2"
                        value={searchTerm}
                        onChange={handleSearch}
                      />
                      <button className="btn btn-sm btn-secondary">
                        <FaSearch />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                  {filteredProjects.map((project) => (
                    <div className="col" key={project.id}>
                      <div
                        className="card h-100"
                        style={{
                          borderLeft: `5px solid ${getCardColor(project.id)}`,
                        }}
                      >
                        <div className="card-body">
                          <h5 className="card-title">{project.name}</h5>
                          <p className="card-text">
                            <strong>Location:</strong> {project.locations}
                          </p>
                          <p className="card-text">
                            <strong>Date:</strong> {project.startDate}
                          </p>
                        </div>
                        <div className="card-footer d-flex justify-content-between">
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => handleAddBatch(project.id)}
                          >
                            Create Batch
                          </button>
                          <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => handleManageBatch(project.id)}
                          >
                            Manage Batch
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                  {filteredProjects.length === 0 && (
                    <div className="col">
                      <p>No projects found.</p>
                    </div>
                  )}
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}
